import {h} from 'preact';
import register from 'preact-custom-element';
import MidnightCountdown from '@/components/MidnightCountdown'

const renderMidnightCountdown = ({ }) => {
    return h(MidnightCountdown, {  })
}


register(renderMidnightCountdown, 'midnight-countdown', []);
